
export function setExpensesTotal(value, application) {
    
    var total=
    parseFloat(application.expenses.rentMortgage) +
    parseFloat(application.expenses.food) +
    parseFloat(application.expenses.carPayment) +
    parseFloat(application.expenses.carInsurance) +
    parseFloat(application.expenses.transport) +
    parseFloat(application.expenses.childCare) +
    parseFloat(application.expenses.cable) +
    parseFloat(application.expenses.internet) +
    parseFloat(application.expenses.diapers)+
    parseFloat(application.expenses.water) +
    parseFloat(application.expenses.electricity) +
    parseFloat(application.expenses.gas) +
    parseFloat(application.expenses.otherUtilities) +
    parseFloat(application.expenses.telephone) +
    parseFloat(application.expenses.laundry)+
    parseFloat(application.expenses.houseHoldItems) 
    ;

    application.expenses.total = total;
return total;
}
